<script lang="ts">
	import { page } from '$app/stores';
</script>

<div class="flex flex-col justify-center items-center">
	<h1 class="h1">{$page.status}</h1>

	<h2 class="h2">{$page.error?.message}</h2>
</div>
